// Agent Marketing - Packages data

export const agentPackages = [
  {
    id: "foundation",
    name: "Foundation",
    tagline: "The essentials, built properly.",
    setup: "$795",
    monthly: "$99",
    monthlyLabel: "/month",
    best: "For agents building the marketing foundation around their name for the first time.",
    features: [
      "Personal brand identity",
      "Logo, colours, typography",
      "Business email on your domain",
      "Email signature",
      "Business cards",
      "Facebook and LinkedIn banners",
      "Google Business Profile setup",
      "Social profile alignment",
      "Mini brand guide",
    ],
    monthlyIncludes: [
      "Presence management",
      "Minor updates",
      "Email and domain support",
      "Brand continuity",
    ],
    cta: "Start With Foundation",
    recommended: false,
  },
  {
    id: "growth",
    name: "Growth",
    tagline: "Ongoing visibility and lead generation.",
    setup: "$2,495",
    monthly: "$249",
    monthlyLabel: "/month",
    best: "For agents ready to show up in search, capture leads, and follow up consistently.",
    features: [
      "Everything in Foundation",
      "Personal marketing website",
      "Mobile optimization",
      "Lead capture forms",
      "Local SEO foundations",
      "Analytics and tracking",
      "Enhanced Google Business Profile",
      "Branded listing template starter set",
      "Social post templates",
      "Review request setup",
    ],
    monthlyIncludes: [
      "Website management and hosting",
      "Monthly updates",
      "Content support",
      "Google presence support",
      "Performance review",
    ],
    cta: "Launch Growth Plan",
    recommended: true,
  },
  {
    id: "managed",
    name: "Managed",
    tagline: "Agent Marketing runs the marketing operation.",
    setup: "Starting at $7,500",
    monthly: "$599+",
    monthlyLabel: "/month",
    best: "For established agents and small teams who want a marketing operation without hiring in-house.",
    features: [
      "Everything in Growth",
      "Custom website experience",
      "Landing pages and funnels",
      "CRM setup and pipeline",
      "AI receptionist and missed-call follow-up",
      "Automated review requests",
      "Full listing marketing system",
      "Campaign strategy and paid ads",
      "Ongoing content production",
      "Priority support",
    ],
    monthlyIncludes: [
      "Strategic marketing oversight",
      "Ongoing optimization",
      "Content and campaign management",
      "Automation refinement",
      "Priority revisions",
      "Monthly reporting",
    ],
    cta: "Talk About Managed",
    recommended: false,
  },
];

export const agencyPackages = [
  {
    id: "alignment",
    name: "Alignment",
    tagline: "A professional foundation for the brokerage.",
    setup: "Starting at $2,995",
    monthly: "$199",
    monthlyLabel: "/month",
    best: "Small brokerages that need a professional foundation.",
    features: [
      "Brokerage brand refinement",
      "Basic website or landing page",
      "Domain and hosting support",
      "Branded email addresses",
      "Email signature design",
      "Google Business Profile setup",
      "Social media branding",
      "Basic SEO setup",
      "Internal brand guide",
    ],
    cta: "Request Alignment",
    recommended: false,
  },
  {
    id: "agency-growth",
    name: "Growth",
    tagline: "Grow, recruit, and manage a stronger brand system.",
    setup: "Starting at $7,995",
    monthly: "$499",
    monthlyLabel: "/month",
    best: "Brokerages ready to grow, recruit, and manage a consistent team brand.",
    features: [
      "Everything in Alignment",
      "Custom website up to 15 pages",
      "Recruiting page",
      "Team page system",
      "Agent profile structure",
      "Lead funnel setup",
      "CRM and email automation setup",
      "Content strategy and calendar",
      "Analytics dashboard",
      "Quarterly strategy calls",
    ],
    cta: "Request Growth Plan",
    recommended: true,
  },
  {
    id: "authority-agency",
    name: "Authority",
    tagline: "Operate like a serious regional or national brand.",
    setup: "Starting at $19,995",
    monthly: "$999+",
    monthlyLabel: "/month",
    best: "Brokerages ready to operate like a serious regional brand.",
    features: [
      "Everything in Growth",
      "Custom website ecosystem",
      "Multi-agent brand system",
      "Advanced SEO and AI visibility",
      "Multi-funnel campaign systems",
      "Recruitment funnels",
      "Reputation and review automation",
      "Paid ad support and strategy",
      "Dedicated account management",
      "Monthly strategy planning",
    ],
    cta: "Request Authority Plan",
    recommended: false,
  },
];

export const perAgentAddOns = [
  "Agent profile page",
  "Agent mini-site",
  "Branded email signature",
  "Agent social banners",
  "Agent business card design",
  "Agent listing template set",
  "Agent Google profile support",
  "Agent content pack",
  "Recruitment or referral landing page",
];
